/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_Next_DocumentInputs */

const en_playbar_next_document = /** @type {(inputs: Playbar_Next_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next Document`)
};

const es_playbar_next_document = /** @type {(inputs: Playbar_Next_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente documento`)
};

/**
* | output |
* | --- |
* | "Next Document" |
*
* @param {Playbar_Next_DocumentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_next_document = /** @type {((inputs?: Playbar_Next_DocumentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_Next_DocumentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_next_document(inputs)
	return en_playbar_next_document(inputs)
});